import React from 'react';
import DocumentsLibrary from '../documents/DocumentsLibrary';

function CouncilDocumentsTab({ slug, info, api }) {
  return <DocumentsLibrary api={api} base={`/${slug}/documents`} canEdit={!!info.membership} practice={!!info.test} />;
}

export default CouncilDocumentsTab;
